import OTPInput from "otp-input-react";
import { React, useState } from "react";
import { Button, Col, Image, Row } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import "../UserValidation/OTP/OTP.css";

import { useEffect } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import email from "../../assets/email.png";
import { getForgotPswdCounter } from "../../Redux/ForgotpswdCounterSlice";
import { userId } from "../../Utils/LocalStorage";
import { existingEmail } from "../API/existing-email";

import { newEmailApi } from "../API/new-email";
import { verifyNewEmailOTP } from "../API/new-email-otp";
import { verifyexistingEmailOTP } from "../API/verify-existing-email-otp";
import Loader from "../Loader/Loader";
import SideBar from "../SideBar/SideBar";
import BackButton from "../BackButton/BackButton";

const OtpEmail = () => {
  const navigate = useNavigate();
  const [OTP, setOTP] = useState("");
  const [OTPErr, setOTPErr] = useState("");
  const [loading, setLoading] = useState(false);
  const { type } = useParams();

  // Redux data 1
  const dispatch = useDispatch();
  const Reduxdata = useSelector((state) => state);
  const mms_city_id = userId();

  const timeperiod = Reduxdata.ForgotpswdCounter.ForgotPswdCounter * 60;
  const newEmail = localStorage.getItem("newEmail");

  // time counter
  const [timer, setTimer] = useState(timeperiod);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleVerifyOtp = async () => {
    let check = true;
    if (OTP.length == 0) {
      setOTPErr("Please Enter the one-time verification code!");
      check = false;
    } else if (OTP.length < 6) {
      setOTPErr("Please Enter all 6 digits!");
      check = false;
    }

    const oldEmailData = {
      mms_city_id: mms_city_id,
      existing_email_otp: parseInt(OTP),
    };

    const newEmailData = {
      mms_city_id: mms_city_id,
      new_email: newEmail,
      otp: parseInt(OTP),
    };

    if (check === true) {
      if (type === "update-email") {
        try {
          const Response = await verifyexistingEmailOTP(oldEmailData, () => {
            navigate("/");
          });
          if (Response.status === 200) {
            toast.dismiss();
            toast.clearWaitingQueue();
            toast.success(Response.message, {
              position: "top-center",
              width: "500px",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
            navigate("/edit-email");
          } else {
            toast.error(Response.message ?? "Something went wrong.", {
              position: "top-center",
              width: "auto",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        } catch (error) {
          toast.error("Something went wrong.", {
            position: "top-center",
            width: "auto",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      }
      if (type === "new-email") {
        try {
          const Response = await verifyNewEmailOTP(newEmailData, () => {
            navigate("/");
          });
          if (Response.status === 200) {
            toast.dismiss();
            toast.clearWaitingQueue();
            toast.success(Response.message, {
              position: "top-center",
              width: "500px",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
            navigate("/marketplace-setup/profile");
          } else {
            toast.error(Response.message ?? "Something went wrong.", {
              position: "top-center",
              width: "auto",
              autoClose: 1000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "dark",
            });
          }
        } catch (error) {
          toast.error("Something went wrong.", {
            position: "top-center",
            width: "auto",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      }
    }
  };

  const handleResentCode = async () => {
    const Otp_email = localStorage.getItem("Otp_email");
    const oldEmailData = {
      mms_city_id: parseInt(mms_city_id),
      existing_email: Otp_email,
    };
    const newEmailData = {
      mms_city_id: mms_city_id,
      new_email: newEmail,
      otp: parseInt(OTP),
    };
    if (type === "update-email") {
      try {
        const Response = await existingEmail(oldEmailData, () => {
          navigate("/");
        });
        if (Response.status === 200) {
          toast.dismiss();
          toast.clearWaitingQueue();
          toast.success(Response.message, {
            position: "top-center",
            width: "500px",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setTimer(Response.timer * 60);
          dispatch(getForgotPswdCounter(Response.timer));
        } else {
          toast.error(Response.message ?? "Something went wrong.", {
            position: "top-center",
            width: "auto",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      } catch (error) {
        toast.error("Something went wrong.", {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    } else if (type === "new-email") {
      try {
        const Response = await newEmailApi(newEmailData, () => {
          navigate("/");
        });
        if (Response.status === 200) {
          toast.dismiss();
          toast.clearWaitingQueue();
          toast.success(Response.message, {
            position: "top-center",
            width: "500px",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
          setTimer(Response.timer * 60);
          dispatch(getForgotPswdCounter(Response.timer));
        } else {
          toast.error(Response.message ?? "Something went wrong.", {
            position: "top-center",
            width: "auto",
            autoClose: 1000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "dark",
          });
        }
      } catch (error) {
        toast.error("Something went wrong.", {
          position: "top-center",
          width: "auto",
          autoClose: 1000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
      }
    }
  };

  useEffect(() => {
    let intervalId = null;

    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  useEffect(() => {
    setTimer(timeperiod);
  }, [timeperiod]);

  useEffect(() => {
    if (OTP.length != 0) {
      setOTPErr("");
    }
  }, [OTP]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <SideBar />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <BackButton />
          <div>
            <Col md="6" className="email-otp-section">
              <div className="w-100">
                <Image src={email}></Image>
              </div>
              <div className="text-center mb-2">
                <h2 className="mt-5 pb-2">
                  {type === "update-email" ? "Update Email" : "New Email"}
                </h2>
              </div>
              <Row>
                <div className="mt-3 pt-0 pb-3 text-center">
                  <p className="text-center">
                    Please enter the one-time verification code sent to your
                    registered email
                  </p>
                  <p className="text-center" style={{ fontStyle: "italic" }}>
                    (If you haven't received the One-time verification code in
                    your inbox, we kindly request you to check your spam
                    folder.)
                  </p>
                  <OTPInput
                    className="otp-section mt-4 mb-3"
                    value={OTP}
                    onChange={setOTP}
                    autoFocus
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    maxTime={-1}
                  />
                  <div className="p-2">
                    {OTPErr ? (
                      <span className="star-required Errlabel-font_size">
                        {OTPErr}
                      </span>
                    ) : timer !== 0 ? (
                      <p style={{ color: "#e66100" }}>
                        The verification code sent will expire in{" "}
                        {formatTime(timer)} minutes
                      </p>
                    ) : (
                      <></>
                    )}
                  </div>
                  <div
                    className="text-right"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <p
                      className="forgot-text"
                      onClick={handleResentCode}
                      style={{ paddingTop: 23 }}
                    >
                      Resend Code
                    </p>
                  </div>
                  <Button
                    variant="primary"
                    type="submit"
                    className="green-btn mt-2 mb-3 otp-submit"
                    onClick={handleVerifyOtp}
                  >
                    Verify
                  </Button>
                </div>
                <p
                  style={{
                    textAlign: "center",
                    padding: "1.5rem 1rem 0rem 1rem",
                  }}
                >
                  (Do not refresh the page!)
                </p>
              </Row>
            </Col>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpEmail;
